// Request-local dismissal only. Coupon tracking and App behavior remain pending.
function initPurchaseCoupon() {
  const banner = document.querySelector('[data-purchase-coupon]')
  if (!banner || banner.dataset.initialized) return
  const close = banner.querySelector('[data-purchase-coupon-close]')
  if (!close) return
  banner.dataset.initialized = 'true'
  close.addEventListener('click', () => {
    banner.hidden = true
    const heading = document.getElementById('product-purchase-title')
    if (heading) {
      heading.setAttribute('tabindex', '-1')
      heading.focus({ preventScroll: true })
    }
  })
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPurchaseCoupon)
} else {
  initPurchaseCoupon()
}
